module.exports = "/virtual-football-league/img/amblems/right/logos/Dortmund.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Dortmund.png
// module id = 2169
// module chunks = 4